import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, DELETE } from "const"
import { MtGroup } from "server/models"
import { mtGroupsRoute } from "client/parts/routes"
import { hasAccess } from "client/utils"
import { PRM_GROUP, StoreType, addModal } from "client/store"
import {
    Link,
    Default,
    UserIcon,
    DateFormatter,
    TableColumn,
} from "client/components"

const Columns = () => {
    const deleteAccess = hasAccess(PRM_GROUP, DELETE)

    const userList = useSelector((state: StoreType) => state.user.userList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (group: MtGroup) => {
                const href = `${mtGroupsRoute}/${VIEW}/${group.id}`
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        {group.name}
                    </Link>
                )
            },
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellWidth: "200px",
            cellMinWidth: "200px",
            formatter: (group: MtGroup) => {
                if (group.accountId !== userData.accountId && group.accountId === 1) return <Default />

                const user = userList[group.creator]
                return <UserIcon user={user} size="sm" />
            },
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (group: MtGroup) => <DateFormatter date={group.createdAt} />,
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: (group: MtGroup) => {
                if (group.accountId !== userData.accountId) return false
                return deleteAccess || group.creator === userData.userId
            },
        },
    ]

    return columns
}
export default Columns
